import { Context, Plugin } from '@thepassle/app-tools/router.js';
import { PAGE, visit } from './state/pages';
import { store } from './store';
import { Metadata, updateMetadata } from './metadata';


// Plugin that executes a query when routing
export const prefetch = (queryData: (context: Context) => void): Plugin => {
  return {
    name: "prefetch",
    beforeNavigation: queryData
  } as Plugin;
};

export const setMetaData = (metadata: (context: Context) => Metadata): Plugin => {
  return {
    name: "setMetaData",
    afterNavigation: (context:Context) => {
      const md:Metadata = metadata(context);
      updateMetadata(md);
    }
  } as Plugin;
};

// Plugin that add a visit to the routed page in the state
export const visitPage = (page: PAGE): Plugin => {
  return {
    name: "visitPage",
    beforeNavigation: (context: Context) => {
      store.dispatch(visit({
        page,
        url: context.url.href,
        query: context.query,
        params: context.params,
      }));
    }
  } as Plugin;
};

// // Plugin that determines the product search query from 
// // the router context and stores it in the state
// export const storeSearchContext = (): Plugin => {
//   return {
//     name: "storeSearchContext",
//     beforeNavigation: (context: Context) => {
//       const productSearchQuery = extractProductSearchQueryArgs(context.url);
//       const { catId, shopId } = context.params;
//       if (catId) {
//         productSearchQuery.category_ids = (productSearchQuery.category_ids ? productSearchQuery.category_ids.concat([catId]) : [catId]);
//       }
//       if (shopId) {
//         productSearchQuery.shop_ids = (productSearchQuery.shop_ids ? productSearchQuery.shop_ids.concat([shopId]) : [shopId]);
//       }
//       store.dispatch(setProductSearchQueryArgs(productSearchQuery));
//     }
//   } as Plugin;
// };

